$(function() {
    if ($('.testimonials__slideActive')[0]) {
        const scroller = $('.testimonials__slideActive');

        if (scroller.owlCarousel && $('.testimonials__slideItem').length > 1) {
            $(scroller).owlCarousel({
                margin: 1,
                items: 2,
                smartSpeed: 450,
                dots: true,
                nav: false,
                navRewind: false,
                loop: true,
                autoplay: true,
                autoplayTimeout: 10000,
                responsive: {
                    0: {
                        items: 1,
                    },
                    960: {
                        items: 2,
                        margin: 60,
                    },
                    1200: {
                        items: 2,
                        margin: 120,
                    },
                },
            });
        }
    }
});
